import { Dialog, Transition } from '@headlessui/react'
import { Fragment, ReactElement, useEffect, useState } from 'react'

export interface DialogProps {
    show?: boolean
    prompt_message: string | ReactElement
    onCloseModal(): void
    button_position?: 'right' | 'left' | 'center'
    button_message?: string
}
export default function DialogModal({
    show,
    prompt_message = '',
    onCloseModal = (): void => {},
    button_position = 'center',
    button_message = 'Got it, thanks!'
}: DialogProps) {

    function closeModal() {
        onCloseModal()
    }

    return (
        <Transition
            appear
            show={show != undefined ? show : !!(prompt_message)}
            as="div"
            enter="transition-opacity duration-75"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity duration-150"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
        >
            <Dialog
                as="div"
                className="fixed inset-0 z-[300] overflow-y-auto"
                onClose={closeModal}
            >
                <div className="min-h-screen px-4 text-center">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 backdrop-filter backdrop-brightness-50" />
                    </Transition.Child>

                    {/* This element is to trick the browser into centering the modal contents. */}
                    <span
                        className="inline-block h-screen align-middle"
                        aria-hidden="true"
                    >
                        &#8203;
                    </span>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                    >
                        <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-center align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                            <div className="mt-2">
                                <p
                                    className="text-sm text-gray-500"
                                    style={{ minHeight: '2rem' }}
                                >
                                    {prompt_message}
                                </p>
                            </div>

                            <div
                                className="mt-4"
                                style={{ textAlign: button_position }}
                            >
                                <button
                                    type="button"
                                    className="inline-flex justify-center px-4 py-2 text-sm font-medium text-blue-900 bg-blue-100 border border-transparent rounded-md hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                                    onClick={closeModal}
                                >
                                    {button_message}
                                </button>
                            </div>
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition>
    )
}
